import React, { useState, useEffect, useContext, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getPublicAPI } from '../api'
import {
   Box,
   Drawer,
   Hidden,
   Typography,
   Checkbox,
   Button,
   Slider,
   List,
   Avatar,
   Divider,
   Grid,
   Collapse
} from '@material-ui/core'
import { Circle } from 'react-feather'
import {
   UserPlus as UserPlusIcon,
   Wind as HosesIcon,
   GitCommit as FittingsIcon
} from 'react-feather'
import ShoppingCartSharpIcon from '@material-ui/icons/ShoppingCartOutlined'
import NavItem from './NavItem'
// contexts
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'


const MainSidebar = ({ onMobileClose, openMobile }) => {
   const location = useLocation()
   const { innerWidth: windowWidth } = window

   const {
      setUploadedNewFits,
      setSearchC,
      handleSizesC,
      selectedHoseSizesC,
      selectedDashSizesC,
      setSelectedHoseSizesC,
      setSelectedDashSizesC,
      hoseSizesC,
      dashSizesC,
      setPrice,
      price,
      setUploadedNewHos,
      handleHosesC,
      selectedPressuresC,
      selectedSizesC,
      setSelectedPressuresC,
      setSelectedSizesC,
      pressuresC,
      sizesC,
      searchC,
      setHoseSizesC,
      setPressuresC,
      openFittings,
      setOpenFittings,
      openHoses,
      setOpenHoses


   } = useContext(ShoppingCartContext)

   const scrollview = React.useRef(null)
   const buttonRef = useRef(null)
   const buttonRef1 = useRef(null)
   const [minMax, setMinmax] = useState([])
   const [display1, setDisplay] = useState(false)
   const [display2, setDisplay2] = useState(false)
   const [val, setVal] = useState([minMax[0], minMax[1]])
   


   const expand = () => {
      setOpenFittings(!openFittings);
      
   }
   const expandHoses = () => {
      setOpenHoses(!openHoses);
      
   }

   const onButtonclick = () => {
      if (!display1 && !display2) {
         buttonRef.current.style.display = 'block'
         setDisplay(true)
         buttonRef1.current.style.display = 'block'
         setDisplay2(true)
      } else if (display1 && display2) {
         buttonRef.current.style.display = 'none'
         setDisplay(false)
         buttonRef1.current.style.display = 'none'
         setDisplay2(false)
      }
   }

   const items = [
      {
         href: '/register',
         icon: UserPlusIcon,
         title: 'Register'
      },

      {
         href: '/view-cart',
         icon: ShoppingCartSharpIcon,
         title: 'Cart'
      },

      {
         href: '/hoses',
         icon: HosesIcon,
         title: 'Hoses'
      },
      {
         href: '/fittings',
         icon: FittingsIcon,
         title: 'Fittings'
      }
   ]

   const item = [
      {
         value: 0,
         label: 0
      },
      {
         value: parseInt(minMax[1] * 0.2),
         label: parseInt(minMax[1] * 0.2)
      },

      {
         value: parseInt(minMax[1] * 0.4),
         label: parseInt(minMax[1] * 0.4)
      },
      {
         value: parseInt(minMax[1] * 0.6),
         label: parseInt(minMax[1] * 0.6)
      },
      {
         value: parseInt(minMax[1] * 0.8),
         label: parseInt(minMax[1] * 0.8)
      },
      {
         value: parseInt(minMax[1]),
         label: parseInt(minMax[1])
      },
      {
         value: parseInt(minMax[1] * 1.2),
         label: parseInt(minMax[1] * 1.2)
      }
   ]

   const updateRange = (e, data) => {
      setVal(data)
      setPrice(data)
   }

   useEffect(() => {
      async function getRange() {
         let range = await getPublicAPI('/get-range')
         if (range?.success) {
            const { min, max } = range?.data
            let value = []
            value.push(parseInt(min))
            value.push(parseInt(max))
            setMinmax(value)
         } else {
            let value = [0, 100]
            setMinmax(value)
         }
      }

      getRange()
   }, [])

   useEffect(() => {
      if (openMobile && onMobileClose) onMobileClose()
      setSearchC('')

      setUploadedNewFits(false)
      setUploadedNewHos(false)
      setSelectedHoseSizesC([])
      setSelectedPressuresC([])
      setSelectedDashSizesC([])
      setSelectedSizesC([])
      setHoseSizesC([])
      setPressuresC([])
      setPrice([])
   }, [
      location.pathname,
      setSearchC,
      setSelectedDashSizesC,
      setSelectedHoseSizesC,
      setSelectedPressuresC,
      setSelectedSizesC,
      setUploadedNewFits,
      setUploadedNewHos,
      setPrice
   ])

   useEffect(() => {
      if (localStorage.uploaded) {
         if (localStorage.uploaded === 'Fits') setUploadedNewFits(true)
         else setUploadedNewHos(true)

         localStorage.removeItem('uploaded')
      }
   }, [setUploadedNewFits, setUploadedNewHos])

   const clearFilters = () => {
      setSelectedDashSizesC([])
      setSelectedHoseSizesC([])
      setSelectedPressuresC([])
      setSelectedSizesC([])
      setPrice([])
      setVal([minMax[0], minMax[1]])
   }

   

   const content = (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
         }}
      >
         <Box sx={{ p: 2 }}>
            {windowWidth > 425 && (
               <Box
                  sx={{
                     p: 1,
                     mb: 2,
                     justifyContent: 'space-between',
                     minWidth: '300'
                  }}
                  ref={scrollview}
               >
                  {(((pressuresC.length > 0 || sizesC.length > 0) && location.pathname !== '/fittings') ||
                     (((hoseSizesC.length > 0 || dashSizesC.length > 0) && location.pathname !== '/fittings')
                        && ((pressuresC.length > 0 || sizesC.length > 0) && location.pathname !== '/hoses')) ||
                     ((hoseSizesC.length > 0 || dashSizesC.length > 0) && location.pathname !== '/hoses')) &&
                     <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>Filters:</Typography>
                        <Button
                           disabled={
                              !(
                                 selectedDashSizesC.length > 0 ||
                                 selectedHoseSizesC.length > 0 ||
                                 selectedPressuresC.length > 0 ||
                              selectedSizesC.length > 0 ||
                              price.length > 0
                              )
                           }
                           onClick={clearFilters}
                           variant='contained'
                        >
                           Clear
                     </Button>
                     </Box>
                  }
                  <Box sx={{ mt: 1 }}>
                     {(hoseSizesC.length > 0 && pressuresC.length > 0 && location.pathname !== '/fittings' && location.pathname !== '/hoses') && (
                           <>
                              <Box sx={{ mb: 1 }} >
                                 <Button
                                    fullWidth
                                    sx={{ justifyContent: 'left',pl:0 }}
                                    onClick={expand}
                                 >
                                    <Grid container spacing={1}>
                                       <Grid item xs={6}>
                                          <Typography
                                             sx={{ fontSize: '16px', fontWeight: '500', float: 'left', color: '#838784' }}
                                          >
                                             Fittings{' '}
                                          </Typography>
                                       </Grid>
                                       <Grid item xs={6}>
                                       {openFittings ? <ExpandLessIcon sx={{ color: '#838784', float: 'right', }} /> : <ExpandMoreIcon sx={{ color: '#838784', float: 'right', }} />}
                                       </Grid>
                                    </Grid>
                                 </Button>
                                 <Collapse in={openFittings} timeout="auto" unmountOnExit >
                                    <Box >
                                       <Typography sx={{ fontSize: '14px', fontWeight: '500', ml: 2 }}>
                                          Pressures
                                         </Typography>
                                       {hoseSizesC.map(size => (
                                          <Typography key={size}>
                                             <Checkbox
                                                checked={selectedHoseSizesC.includes(size)}
                                                color='primary'
                                                onChange={() => {
                                                   // if (selectedPressuresC.length !== 0 || selectedSizesC.length !== 0) {
                                                   //    const obj = {}; obj.type = 'hose'; obj.size = size;
                                                   //    setSelectedPressuresC([]); setSelectedSizesC([]);
                                                   //    socket.emit("handleSizes", JSON.stringify(obj))

                                                   // }
                                                   // else {
                                                   handleSizesC('hose', size); 
                                                   scrollview.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                                   // }
                                                }}
                                             />
                                             {`-${size.slice(-2)}`}
                                          </Typography>
                                       ))}
                                       <Typography sx={{ fontSize: '14px', fontWeight: '500', ml: 2 }}>
                                          Sizes
                                             </Typography>
                                       {dashSizesC.map(size => (
                                          <Typography key={size}>
                                             <Checkbox
                                                checked={selectedDashSizesC.includes(size)}
                                                color='primary'
                                                onChange={() => {
                                                   // if (selectedPressuresC.length !== 0 || selectedSizesC.length !== 0) {
                                                   //    const obj = {}; obj.type = 'dash'; obj.size = size;
                                                   //    setSelectedPressuresC([]); setSelectedSizesC([]); socket.emit("handleSizes", JSON.stringify(obj))
                                                   // }
                                                   // else {
                                                   handleSizesC('dash', size); 
                                                   scrollview.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                                   // }
                                                }}
                                             />
                                             {`-${size.slice(-2)}`}
                                          </Typography>
                                       ))}
                                    </Box>
                                 </Collapse>

                                 <Button
                                    fullWidth
                                    sx={{ justifyContent: 'left',pl:0 }}
                                    onClick={expandHoses}
                                 >
                                    <Grid container spacing={3}>
                                       <Grid item xs={3}>
                                          <Typography
                                             sx={{ fontSize: '16px', fontWeight: '500', float: 'left', color: '#838784' }}
                                          >
                                             Hoses{' '}
                                          </Typography>
                                       </Grid>
                                       <Grid item xs={9}>
                                       {openHoses ? <ExpandLessIcon sx={{ color: '#838784', float: 'right' }} /> : <ExpandMoreIcon sx={{ color: '#838784', float: 'right' }} />}
                                       </Grid>
                                    </Grid>
                                 </Button>
                                 <Collapse in={openHoses} timeout="auto" unmountOnExit>
                                    <Box >
                                       <Typography sx={{ fontSize: '14px', fontWeight: '500', ml: 2 }}>
                                          Pressures
                                    </Typography>
                                       {pressuresC.map(size => (
                                          <Typography key={size}>
                                             <Checkbox
                                                checked={selectedPressuresC.includes(size)}
                                                color='primary'
                                                onChange={() => {
                                                   handleHosesC('pressure', size);
                                                   
                                                   scrollview.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                                   // setSelectedHoseSizesC(''); setSelectedDashSizesC('');
                                                   // socket.emit("handleHoses")
                                                }}
                                             />
                                             {`-${size.slice(-2)}`}
                                          </Typography>
                                       ))}
                                       <Typography sx={{ fontSize: '14px', fontWeight: '500', ml: 2 }}>
                                          Sizes
                                             </Typography>
                                       {sizesC.map(size => (
                                          <Typography key={size}>
                                             <Checkbox
                                                checked={selectedSizesC.includes(size)}
                                                color='primary'
                                                onChange={() => {
                                                   handleHosesC('size', size);
                                                   scrollview.current.scrollIntoView({ behavior: 'smooth', block: 'start' })   }}
                                             />
                                             {`-${size.slice(-2)}`}
                                          </Typography>
                                       ))}
                                    </Box>
                                 </Collapse>
                              </Box>

                           </>
                        )}


                     {((hoseSizesC.length > 0 && location.pathname === '/fittings')
                        || (hoseSizesC.length > 0 && pressuresC.length === 0 && location.pathname !== '/hoses' )) && (
                        <Box sx={{ mb: 1 }}>
                           <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
                              Pressures
                           </Typography>
                           {hoseSizesC.slice(0, 2).map(size => (
                              <Typography key={size}>
                                 <Checkbox
                                    checked={selectedHoseSizesC.includes(size)}
                                    color='primary'
                                    onChange={() => handleSizesC('hose', size)}
                                 />
                                 {`-${size.slice(-2)}`}
                              </Typography>
                           ))}
                           <Typography ref={buttonRef1} style={{ display: 'none' }}>
                              {hoseSizesC.slice(2, hoseSizesC.length).map(size => (
                                 <Typography key={size}>
                                    <Checkbox
                                       checked={selectedHoseSizesC.includes(size)}
                                       color='primary'
                                       onChange={() => handleSizesC('hose', size)}
                                    />
                                    {`-${size.slice(-2)}`}
                                 </Typography>
                              ))}
                           </Typography>
                        </Box>
                     )}
                     {((pressuresC.length > 0 && location.pathname === '/hoses')
                        || (pressuresC.length > 0 && hoseSizesC.length === 0  && location.pathname !== '/fittings' )) && (
                        <Box sx={{ mb: 1 }}>
                           <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
                              Pressures
                           </Typography>
                           {pressuresC.slice(0, 2).map(size => (
                              <Typography key={size}>
                                 <Checkbox
                                    checked={selectedPressuresC.includes(size)}
                                    color='primary'
                                    onChange={() => handleHosesC('pressure', size)}
                                 />
                                 {`-${size.slice(-2)}`}
                              </Typography>
                           ))}
                           <Typography ref={buttonRef1} style={{ display: 'none' }}>
                              {pressuresC.slice(2, pressuresC.length).map(size => (
                                 <Typography key={size}>
                                    <Checkbox
                                       checked={selectedPressuresC.includes(size)}
                                       color='primary'
                                       onChange={() => handleHosesC('pressure', size)}
                                    />
                                    {`-${size.slice(-2)}`}
                                 </Typography>
                              ))}
                           </Typography>
                        </Box>
                     )}
                     {((dashSizesC.length > 0 && location.pathname === '/fittings')
                        || (dashSizesC.length > 0 && sizesC.length === 0 && location.pathname !== '/hoses' )) && (
                        <Box ref={buttonRef} style={{ display: 'none' }}>
                           <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
                              Sizes
                           </Typography>
                           {dashSizesC.map(size => (
                              <Typography key={size}>
                                 <Checkbox
                                    checked={selectedDashSizesC.includes(size)}
                                    color='primary'
                                    onChange={() => handleSizesC('dash', size)}
                                 />
                                 {`-${size.slice(-2)}`}
                              </Typography>
                           ))}
                        </Box>
                     )}
                     {((sizesC.length > 0 && location.pathname === '/hoses')
                        || (sizesC.length > 0 && dashSizesC.length === 0 && location.pathname !== '/fittings' )) && (
                        <Box ref={buttonRef} style={{ display: 'none' }}>
                           <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
                              Sizes
                           </Typography>
                           {sizesC.map(size => (
                              <Typography key={size}>
                                 <Checkbox
                                    checked={selectedSizesC.includes(size)}
                                    color='primary'
                                    onChange={() => handleHosesC('size', size)}
                                 />
                                 {`-${size.slice(-2)}`}
                              </Typography>
                           ))}
                        </Box>
                     )}
                   
                        <Button
                           onClick={onButtonclick}
                           fullWidth
                        sx={{ marginTop: '0', display: 'block' }}
                        disabled={
                           (
                              hoseSizesC.length > 0 &&
                              pressuresC.length > 0 &&
                              location.pathname !== '/hoses'
                              && location.pathname !== '/fittings'
                           )
                        }
                        >
                           <Circle
                              size='8'
                              style={{
                                 color: 'b5aeb4',
                                 backgroundColor: 'b5aeb4',
                                 margin: '2'
                              }}
                           />
                           <Circle
                              size='8'
                              style={{
                                 color: 'b5aeb4',
                                 backgroundColor: 'b5aeb4',
                                 margin: '2'
                              }}
                           />
                           <Circle
                              size='8'
                              style={{
                                 color: 'b5aeb4',
                                 backgroundColor: 'b5aeb4',
                                 margin: '2'
                              }}
                           />
                        </Button>
                    
                     <Typography
                        id='discrete-slider-custom'
                        pt={0}
                        pb={4}
                        gutterBottom
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                     >
                        Price Range($)
                     </Typography>
                     <Slider
                        aria-labelledby='discrete-slider-custom'
                        color='primary'
                        valueLabelDisplay='on'
                        defaultValue={parseInt(minMax[1] * 1.2)}
                        value={val}
                        onChange={updateRange}
                        marks={item}
                        min={parseInt(minMax[0])}
                        max={parseInt(minMax[1] * 1.2)}
                     />
                  </Box>
               </Box>
            )}
         </Box>
         <Box sx={{ flexGrow: 1 }} />
      </Box>
   )

   const navigate = useNavigate()

   const [loading, setLoading] = useState(true)

   useEffect(() => {
      let mounted = true

      mounted && setLoading(false)

      return () => (mounted = false)
   }, [navigate])

   return (
      <>
         {(searchC && (hoseSizesC.length > 0 || dashSizesC.length > 0)) ||
         (searchC && (pressuresC.length > 0 || sizesC.length > 0)) ? (
            <>
               {/* <Box lgUp>
                  {loading ? (
                     <></>
                  ) : (
                     <Drawer
                        anchor='left'
                        onClose={onMobileClose}
                        open={openMobile}
                        variant='temporary'
                        PaperProps={{
                           sx: {
                              width: 256
                           }
                        }}
                     >
                              {content}
                             
                     </Drawer>
                  )}
               </Box> */}

                  <Hidden lgDown>
                  {loading ? (
                     <></>
                  ) : (
                     <Drawer
                        anchor='left'
                        open
                        variant='persistent'
                        PaperProps={{
                           sx: {
                              width: 256,
                              top: 64,
                              height: 'calc(100% - 64px)'
                           }
                        }}
                     >
                        {content}
                     </Drawer>
                  )}

                  </Hidden>
            </>
         ) : (
            <>
                  <Hidden lgUp>
                  {loading ? (
                     <></>
                  ) : (
                     <Drawer
                        anchor='left'
                        onClose={onMobileClose}
                        open={openMobile}
                        variant='temporary'
                        PaperProps={{
                           sx: {
                              width: 256
                           }
                        }}
                     >
                        <Box
                           sx={{
                              alignItems: 'center',
                              display: 'flex',
                              flexDirection: 'column',
                              p: 2
                           }}
                        >
                           <Avatar
                              sx={{
                                 cursor: 'pointer',
                                 width: 64,
                                 height: 64
                              }}
                           />

                           <Button onClick={() => navigate('/login')} fullWidth sx={{ mt: 1 }}>
                              Sign in
                           </Button>
                        </Box>
                        <Divider />
                        <Box sx={{ ml: 1 }}>
                           <List>
                              {items.map((item, index) => (
                                 <NavItem
                                    href={item.href}
                                    key={index}
                                    title={item.title}
                                    icon={item.icon}
                                 />
                              ))}
                           </List>
                        </Box>
                     </Drawer>
                  )}

                  </Hidden>

                  <Hidden lgDown>
                  {loading ? (
                     <></>
                  ) : (
                     <Drawer
                        anchor='left'
                        onClose={onMobileClose}
                        open={openMobile}
                        variant='temporary'
                        PaperProps={{
                           sx: {
                              width: 256,
                              top: 64,
                              height: 'calc(100% - 64px)'
                           }
                        }}
                     >
                        <Box
                           sx={{
                              alignItems: 'center',
                              display: 'flex',
                              flexDirection: 'column',
                              p: 2
                           }}
                        >
                           <Avatar
                              sx={{
                                 cursor: 'pointer',
                                 width: 64,
                                 height: 64
                              }}
                           />

                           <Button onClick={() => navigate('/login')} fullWidth sx={{ mt: 1 }}>
                              Sign in
                           </Button>
                        </Box>
                        <Divider />
                        <Box sx={{ ml: 1 }}>
                           <List>
                              {items.map((item, index) => (
                                 <NavItem
                                    href={item.href}
                                    key={index}
                                    title={item.title}
                                    icon={item.icon}
                                 />
                              ))}
                           </List>
                        </Box>
                     </Drawer>
                  )}
                  </Hidden>
            </>
         )}
      </>
   )
}

MainSidebar.propTypes = {
   onMobileClose: PropTypes.func,
   openMobile: PropTypes.bool
}

MainSidebar.defaultProps = {
   onMobileClose: () => {},
   openMobile: false
}

export default MainSidebar
